module.exports = __webpack_public_path__ + "img/gold-icon.080e8225.svg";